import AuthContext from "context/AuthContext";
import { useContext } from "react";
import BoxFiltersContainers from "./waste/BoxFiltersContainers";
import BoxFiltersContainersBridge from "./bridge/BoxFiltersContainersBridge";

const BoxFilterContainersManager = ({ show, filters, filtersParams }) => {
    const { panel } = useContext(AuthContext);

    switch (panel.panel_type) {
        case 'b':
            return <BoxFiltersContainersBridge show={show} filters={filters} filtersParams={filtersParams} />
        default:
            return <BoxFiltersContainers show={show} filters={filters} filtersParams={filtersParams} />
    };
};
export default BoxFilterContainersManager;